import { render, staticRenderFns } from "./NewDetail.vue?vue&type=template&id=702585ee&scoped=true&"
import script from "./NewDetail.vue?vue&type=script&lang=js&"
export * from "./NewDetail.vue?vue&type=script&lang=js&"
import style0 from "./NewDetail.vue?vue&type=style&index=0&id=702585ee&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702585ee",
  null
  
)

export default component.exports